import { useState } from 'react'

import { OnboardingContext } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/Onboarding/OnboardingContext'

export default function OnboardingProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [onboardingMode, setOnboardingMode] = useState(false)
  const [stepIndex, setStepIndex] = useState(0)

  return (
    <OnboardingContext.Provider
      value={{
        stepIndex,
        setStepIndex,
        onboardingMode,
        setOnboardingMode,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  )
}
